import NewsletterSignUp from "@src/app/components/NewsletterSignUp";
import Space from "@src/app/components/Space";
import StaticSection from "@src/app/components/StaticSection";
import { createMetaTags } from "@src/app/utils/createMetaTags";

export const meta = () =>
  createMetaTags({
    title: "Newsletter | Big Reads, Opinions & Columns on China | ThinkChina",
    description:
      "Newsletters - Sign up for our weekly and fortnightly newsletters and get the latest stories, insights and analysis on China.",
    canonical: `https://www.thinkchina.sg/newsletter`,
    ogInfo: {
      ogTitle: "Newsletter | Big Reads, Opinions & Columns on China ",
    },
  });

export default function NewsLetterPage() {
  return (
    <div className="container mx-auto max-w-[1200px]">
      <StaticSection title="Sign up for our Newsletters">
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-6">
          <NewsletterSignUp variant="card" className="h-full px-0!" />
          <NewsletterSignUp variant="cultureCard" className="h-full px-0!" />
        </div>
      </StaticSection>
      <Space />
    </div>
  );
}
